import React, { useEffect, forwardRef, useImperativeHandle, useState } from 'react';
import { Form, Input, message, Button } from 'antd';
import ApiServices from '~services';
import { formatFields } from './fields-data';

const defaultFieldData = formatFields({});

export const FormInput = forwardRef(({ dataInput, reload, onClose }, ref) => {
  const [fields, setFields] = useState(defaultFieldData);
  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    submitForm() {
      form.submit();
    },
  }));

  useEffect(() => {
    form.resetFields();
    if (!dataInput?.id) {
      return setFields(defaultFieldData);
    }
    setFields(formatFields(dataInput));
  }, [dataInput?.id]);

  const onSubmitForm = (value) => {
    if (!dataInput?.id) {
      return ApiServices.createGroup(value)
        .then(() => {
          reload?.();
          onClose?.();
          message.success('Thao tác thành công!!!');
        })
        .catch((err) => {
          console.error('Create Menu', err);
          message.error('Thao tác thất bại');
        });
    }
    return ApiServices.updateGroup(dataInput.id, { ...value, id: dataInput.id })
      .then(() => {
        reload?.();
        onClose?.();
        message.success('Thao tác thành công!!!');
      })
      .catch((err) => {
        console.error('update Menu', err);
        message.error('Thao tác thất bại');
      });
  };
  const onFieldsChanged = (_, allFields) => {
    setFields(allFields);
  };

  return (
    <>
      <Form
        labelCol={{
          span: 6,
        }}
        // labelAlign='left'
        form={form}
        layout='horizontal'
        name='global_state'
        className='form-job-handle'
        onFinish={onSubmitForm}
        fields={fields}
        onFieldsChange={onFieldsChanged}
      >
        <Form.Item
          name='code'
          label='mã'
          rules={[
            {
              required: true,
              message: 'Bạn phải nhập Mã Nhóm',
            },
          ]}
        >
          <Input placeholder='Tên' />
        </Form.Item>
        <Form.Item
          name='name'
          label='Tên'
          rules={[
            {
              required: true,
              message: 'Bạn phải nhập Tên',
            },
          ]}
        >
          <Input placeholder='Tên' />
        </Form.Item>

        <Form.Item name='desc' label='Mô tả'>
          <Input.TextArea placeholder='mô tả' />
        </Form.Item>

        <Form.Item label='Thao tác'>
          <Button type='primary' htmlType='submit'>
            Hoàn Thành
          </Button>
        </Form.Item>
      </Form>
    </>
  );
});
